import { useLang } from 'hooks/lang';

import {
  Column,
  DropdownMenu,
  DropdownMenuItem,
  IconButton,
  ComponentOrNode,
} from 'components/Blocks';
import { UserAvatarGroup } from 'components/UserAvatar';
import { UserPenIcon } from 'components/Icons';

import { useTaskModal } from '../context.taskModal';
import { useModalsTaskOption } from '../taskModalOption.hook';

export function TaskOwner() {
  const { t } = useLang();

  const { task } = useTaskModal();

  const changeOwner = useModalsTaskOption('CHANGE_OWNER');

  const changeSubOwner = useModalsTaskOption('CHANGE_SUB_OWNER');

  const removeSubOwner = useModalsTaskOption('REMOVE_SUB_OWNER');

  const canChange = changeOwner.isEnabled || changeSubOwner.isEnabled;

  const hasSub = !!task.subOwner;

  if (!canChange)
    return (
      <Column alignItems="center" gap="2" relative>
        <UserAvatarGroup
          users={[task.owner, task.subOwner]}
          size={hasSub ? 54 : 72}
          avatarClassName="text-2xl small_tablet:!size-10"
        />
      </Column>
    );

  const trigger = (
    <IconButton
      onClick={changeSubOwner.isEnabled ? undefined : changeOwner.action}
      className="absolute -bottom-1.5 -left-3 p-0.5"
      tooltipContent={t('change')}
    >
      <UserPenIcon size={14} />
    </IconButton>
  );

  return (
    <Column alignItems="center" gap="2" relative>
      <UserAvatarGroup
        users={[task.owner, task.subOwner]}
        size={hasSub ? 54 : 72}
        avatarClassName="text-2xl small_tablet:!size-10"
      />

      {changeSubOwner.isEnabled ? (
        <DropdownMenu trigger={trigger} align="end">
          {changeOwner.isEnabled && (
            <DropdownMenuItem onClick={changeOwner.action}>
              <ComponentOrNode target={changeOwner.Icon} />
              {changeOwner.getLabel?.(t)}
            </DropdownMenuItem>
          )}

          {changeSubOwner.isEnabled && (
            <DropdownMenuItem onClick={changeSubOwner.action}>
              <ComponentOrNode target={changeSubOwner.Icon} />
              {changeSubOwner.getLabel?.(t)}
            </DropdownMenuItem>
          )}

          {removeSubOwner.isEnabled && (
            <DropdownMenuItem onClick={removeSubOwner.action}>
              <ComponentOrNode target={removeSubOwner.Icon} />
              {removeSubOwner.getLabel?.(t)}
            </DropdownMenuItem>
          )}
        </DropdownMenu>
      ) : (
        trigger
      )}
    </Column>
  );
}
